import { useEffect, useState } from 'react'

import ArrowsDown from '../ArrowsDown/ArrowsDown'
import AngleLeft from '../Icons/AngleLeft'
import { InnerContainer } from './InnerContainer'

const MobileContainer = ({ section, className, color, secondary, title, items, children, onClick, setLock, scrollRight }) => {
  const [titleOffset, setTitleOffset] = useState(70)

  useEffect(() => {
    let viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    const onresize = () => {
      const newViewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      if (newViewportHeight !== viewportHeight) {
        if (newViewportHeight < viewportHeight) {
          // Android Chrome address bar has appeared
          setTitleOffset(Math.abs(newViewportHeight - viewportHeight))
        } else {
          // Android Chrome address bar has disappeared
          setTitleOffset(0)
        }
      }
      viewportHeight = newViewportHeight
    }
    onresize()
    window.addEventListener('resize', () => onresize())
    return window.removeEventListener('resize', () => onresize())
  }, [])

  useEffect(() => {
    const sec = document.getElementById(`scroll-container-${section}`)
    const scroll = () => {
      const posX = sec.scrollLeft
      setLock(posX > 50)
    }
    sec.addEventListener('scroll', scroll)
    return () => sec.removeEventListener('scroll', scroll)
  }, [])

  return (
    <div className={`main-page ${color} ${className}`}>
      <div className="inner-page" id={`scroll-container-${section}`}>
        <div className="left side">
          <div className="header">
            <div className="logo-container">
              <img src={`/svg/logo-uam/logo-uam-estudiantes-${color}.svg`} alt="UAM Estudiantes" />
            </div>
          </div>

          <div className="front-logo-container">{children}</div>

          <div className="footer" onClick={() => scrollRight(false)} style={{ bottom: titleOffset }}>
            <div className="text-block">
              <h2 className={`${color}`}>
                <span className={`urbana uppercase text-title`}>{title}</span>
              </h2>
            </div>
            <div className="arrows-container">
              <ArrowsDown color={color} />
            </div>
          </div>
        </div>
        <div className="right side">
          <div className={`index-container ${color}`}>
            <div className="title-container-inside">
              <h2 className={`urbana uppercase text-title ${color}`}>{title}</h2>
            </div>
            <InnerContainer items={items} color={secondary} onClick={onClick} />
            <div className={`back-square ${color}`} />
          </div>

          <div className="bottom-container">
            <div className="go-back" onClick={() => scrollRight(true)}>
              <div className="back-icon-container">
                <AngleLeft color={secondary} />
              </div>
              <span className="text-normal">Volver</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileContainer
